"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Repository = void 0;
var library_1 = require("../elm/library");
var Repository = /** @class */ (function () {
    function Repository(data) {
        this.data = data;
        this.libraries = Array.from(Object.values(data));
    }
    Repository.prototype.resolve = function (path, version) {
        for (var _i = 0, _a = this.libraries; _i < _a.length; _i++) {
            var lib = _a[_i];
            if (lib.library && lib.library.identifier) {
                var _b = lib.library.identifier, id = _b.id, system = _b.system, libraryVersion = _b.version;
                var libraryUri = "".concat(system, "/").concat(id);
                if (path === libraryUri || path === id) {
                    if (version) {
                        if (libraryVersion === version) {
                            return new library_1.Library(lib, this);
                        }
                    }
                    else {
                        return new library_1.Library(lib, this);
                    }
                }
            }
        }
    };
    return Repository;
}());
exports.Repository = Repository;
//# sourceMappingURL=repository.js.map